import React from 'react';
import LinkButton from '../LinkButton/LinkButton';

type TerritorySeeAllButtonProps = {
  url: string;
};

export const TerritorySeeAllButton = ({ url }: TerritorySeeAllButtonProps) => (
  <LinkButton
    href={url}
    variant="ghost"
    className="!text-sm !border-t2-neutral-grey03 hover:!bg-t2-neutral-grey03 !shadow-none"
  >
    See All
  </LinkButton>
);
